import { createSkeletonProvider } from '@trainline/react-skeletor'
import gql from 'graphql-tag'
import * as React from 'react'
import { Query } from 'react-apollo'
import styled from 'styled-components'
import Radio from 'web-makeup/dist/Radio'
import { RadioChangeEvent } from 'antd/lib/radio'

import createSkeletonElement from './../../helpers/tomb'
import { GetAllServiceQualityLevels } from './../../typings/types'

const RadioGroup = Radio.Group

export const StyledRadioGroup = styled(RadioGroup)`
  && {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`

const RadioProvider = createSkeletonProvider(
  { children: '_______' },
  ({ children }) => children === undefined
)(createSkeletonElement(Radio))

export const StyledRadio = styled<{
  disabled?: boolean
  value?: string | null
}>(RadioProvider)`
  && {
    padding: 0.5rem;
    ${props => (!props.value ? '> span { color: transparent; }' : '')};
  }
`

export const GET_ALL_SERVICE_QUALITY_LEVELS = gql`
  query getAllServiceQualityLevels {
    allServiceQualityLevels {
      name
      slug
    }
  }
`

interface Props {
  disabled?: boolean
  onChange?: (event: RadioChangeEvent) => void
  defaultValue?: string | null
  value?: string
}

export class AllServiceQualityLevelsQuery extends Query<
  GetAllServiceQualityLevels.Query,
  GetAllServiceQualityLevels.Variables
> {}

interface SQLProps {
  data?: GetAllServiceQualityLevels.Query['allServiceQualityLevels']
  loading: boolean
}

export const SQL: React.SFC<SQLProps> = ({ data, loading }: SQLProps) =>
  loading ? (
    <React.Fragment>
      {[1, 2, 3, 4].map(i => (
        <StyledRadio key={i} disabled />
      ))}
    </React.Fragment>
  ) : (
    <React.Fragment>
      {data
        ? data.map(({ name, slug }) => (
            <StyledRadio key={slug ? slug : undefined} value={slug}>
              {name}
            </StyledRadio>
          ))
        : null}
    </React.Fragment>
  )

// Cannot be SFC because it needs to be used with `getFieldDecorator`.
class ServiceQualityLevels extends React.Component<Props> {
  render() {
    const { onChange, value, defaultValue, disabled } = this.props

    return (
      <StyledRadioGroup
        disabled={disabled}
        name="sql"
        onChange={onChange}
        defaultValue={value || defaultValue}
      >
        <AllServiceQualityLevelsQuery query={GET_ALL_SERVICE_QUALITY_LEVELS}>
          {({ data, loading }) => (
            <SQL data={data && data.allServiceQualityLevels} loading={loading} />
          )}
        </AllServiceQualityLevelsQuery>
      </StyledRadioGroup>
    )
  }
}

export default ServiceQualityLevels



// WEBPACK FOOTER //
// ./src/components/ServiceQualityLevels/ServiceQualityLevels.tsx